/**
 * 任务日志API
 *
 * @author Jay Qing
 * @since 2021/08/26
 */

 import request from '@/utils/request'

 /**
  * 基础接口
  *
  * @type {string}
  */
 const BASE_URL = 'common/job-log'
 export const JOB_LOG_BASE_URL = 'common/job-log'
 
 /**
  * 分页查询接口
  *
  * @type {string}
  */
 export const JOB_LOG_PAGE_URL = `${BASE_URL}/page`
 
 /**
  * 删除数据
  *
  * @param term 删除条件
  * @returns {Promise}
  */
 export function remove(term: any) {
   return request({
     url: BASE_URL,
     method: 'delete',
     data: term
   })
 }
 